import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './index'
import {
  Message
} from 'element-ui'
import store from '@/store/index'
import {
  DynamicRoutes
} from '@/router/index'
import {
  GetRequest,
  setToken,
  removeToken,
  getToken
} from '@/utils/auth.js'
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
let router = new Router({
  routes
})
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.path === '/login') {
    localStorage.clear()
    store.commit('SET_MENULIST', [])
    removeToken()
    if (to.query.client) {
      next()
    } else {
      if (sessionStorage.getItem('client')) {
        next({
          ...to,
          query: {
            client: sessionStorage.getItem('client')
          }
        })
      } else {
        next()
      }
    }
  }
  if (GetRequest('token')) setToken(GetRequest('token'))
  let token = getToken()
  if (!token && to.path !== '/login') {
    next({
      path: '/login'
    })
    NProgress.done()
  } else {
    // 面包屑数据
    store.commit('SET_BREADCRUMBLIST', to.matched)
    if (store.state.login.menuList.length === 0 && to.path !== '/login') {
      store.dispatch('getmenu').then(res => {
        if (res.length === 0 || res === undefined) {
          Message({
            message: '对不起您菜单权限不足，请联系管理员',
            type: 'error',
            duration: 3 * 1000
          })
          next({
            path: '/login'
          })
        }

        // 增加动态路由
        if (res[0].url) {
          DynamicRoutes[3].redirect = {}
          DynamicRoutes[3].redirect.name = res[0].extra ? res[0].extra : res[0].url
        }
        let menuList = [] // 动态添加的菜单
        // /sys/dict/dictlist
        res.forEach((item, index) => {
          if (item.hidden) return
          var modelobj = {
            path: `/${item.extra ? item.extre : item.url}`,
            name: item.extra ? item.extra : item.url,
            meta: {
              title: item.name,
              icon: item.icon,
              hidden: false
            },
            component: () => import('@/views/home.vue'),
            // redirect: {name: item.children ? item.children[0].url : ''},
            children: []
          }
          if (item.children) {
            modelobj.redirect = {}
            modelobj.redirect.name = item.children[0].extra ? item.children[0].extra : item.children[0].url
          }
          if (item.children) {
            item.children.forEach((item1, index1) => {
              if (item1.hidden) return
              var menuobj = {
                path: item1.url,
                name: item1.url,
                meta: {
                  title: item1.name,
                  icon: item.icon,
                  hidden: false,
                  url: `@/views/${item.url}/${item1.url}/index.vue`
                },
                component: () => import(`@/views/${item.url}/${item1.url}/index.vue`),
                // redirect: {name: item1.children ? item1.children[0].url : ''},
                children: []
              }
              if (item1.children) {
                menuobj.redirect = {}
                menuobj.redirect.name = item1.children[0].extra ? item1.children[0].extra : item1.children[0].url
              }
              modelobj.children.push(menuobj)
              if (item1.children) {
                item1.children.forEach((item2, index2) => {
                  if (item2.hidden) return
                  var obj = {
                    path: item2.extra ? item2.extra : item2.url,
                    name: item2.extra ? item2.extra : item2.url,
                    meta: {
                      title: item2.name,
                      icon: item.icon,
                      hidden: false,
                      url: `@/views/${item.url}/${item1.extra ? item1.extra : item1.url}/${item2.url}.vue`
                    },

                    component: () => import(`@/views/${item.url}/${item1.extra ? item1.extra : item1.url}/${item2.url}.vue`)

                  }
                  // 按钮权限
                  if (item2.children) {
                    var url = []
                    item2.children.forEach((item3) => {
                      if (!item3.hidden) {
                        url.push(item3.url)
                        obj.meta.limitBtn = url
                      }
                    })
                  }

                  menuobj.children.push(obj)
                })
              }
            })
          }
          DynamicRoutes.push(modelobj)
          menuList.push(modelobj)
        })
        // console.log(menuList)
        // 动态添加菜单
        store.commit('SET_MENULIST', menuList)
        // 动态添加可访问路由表
        console.log(store, 'storeneirong')
        router.addRoutes(DynamicRoutes)
        next({
          ...to,
          replace: true
        })
      })
    } else {
      next()
    }
    next()
  }
})

router.afterEach(transition => {
  NProgress.done()
})

router.onError(err => {
  console.log('err: ', err)
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/premission.js